import { PrilohaAktEuDownloadExternalApi } from 'sprava-aktov-eu-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import { spravaAktovEuPrefixPath } from '../configuration/apiConfigurationConstants';
import apiConfiguration from '../configuration/apiConfiguration';

const client = new PrilohaAktEuDownloadExternalApi(apiConfiguration(spravaAktovEuPrefixPath));

const downloadPriloha = async (
  prilohaUuid: string,
  options?: object,
): Promise<ClientResponse<Blob>> => {
  const {
    data,
    status,
  } = await client.downloadPrilohaAktEu(prilohaUuid, { ...options, responseType: 'blob' });
  return {
    data: data && new Blob([data]),
    responseCode: status,
  };
};

export default downloadPriloha;
